import { render } from "./App.vue?vue&type=template&id=b609df02"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b609df02&lang=scss"

import exportComponent from "E:\\zs\\project\\嘉定首页\\reload-jd-home\\node_modules\\_vue-loader@17.0.0@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__